/**
 * Created by huangzhangshu on 2018/8/3
 */
export const wrapImage = (url = '') => {
  if (!url) return '';
  let wrapUrl = url;
  if (wrapUrl[0] !== '/') wrapUrl = wrapUrl.concat('/');
  const servletRoot = localStorage.getItem('static_path') || '';
  return servletRoot.concat(wrapUrl);
}



// WEBPACK FOOTER //
// ./src/utils/index.js